/** Days, yyyy-mm-dd and inclusive, as the admin API takes them; a missing end is open */
export interface DateRange {
  from?: string;
  to?: string;
}

export type PeriodPreset = '30' | '7' | '90' | 'all' | 'custom';

export interface ReportPeriod {
  /** yyyy-mm-dd of a custom period; empty for an open start */
  from: string;
  preset: PeriodPreset;
  /** yyyy-mm-dd of a custom period; empty for an open end */
  to: string;
}

export const WHOLE_RECRUITMENT: ReportPeriod = { from: '', preset: 'all', to: '' };

export const toIsoDate = (date: Date): string =>
  `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;

/**
 * @return the days of the period; the last N days end today
 */
export const toRange = (period: ReportPeriod, today = new Date()): DateRange => {
  if (period.preset === 'all') {
    return {};
  }
  if (period.preset === 'custom') {
    return { from: period.from || undefined, to: period.to || undefined };
  }
  const start = new Date(today);
  start.setDate(start.getDate() - Number(period.preset) + 1);
  return { from: toIsoDate(start) };
};

export const isValidRange = ({ from, to }: DateRange): boolean => !from || !to || from <= to;
